import ReactDOM from 'react-dom/client';
import App from './App';
import './input.css';

// Apply the persisted theme to <html> before the first paint so the whole
// document (including margins) is themed immediately and there is no flash of
// the default theme on load.
document.documentElement.setAttribute(
  "data-theme",
  localStorage.getItem("theme") || "garden"
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

